import {
    FETCH_AUDITTRAIL_REQUEST,
    FETCH_AUDITTRAIL_SUCCESS,
    FETCH_AUDITTRAIL_FAILURE,
  } from "./AuditTrailTypes";
  
  const initialState = {
    loading: false,
    auditTrailList: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_AUDITTRAIL_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_AUDITTRAIL_SUCCESS:
        return {
          loading: false,
          auditTrailList: action.payload,
          error: "",
        };
      case FETCH_AUDITTRAIL_FAILURE:
        return {
          loading: false,
          auditTrailList: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  